module.exports = __webpack_public_path__ + "static/star-13f1a3ba657779271bbca21cc265e7d5.svg";